export type EmployeeExpectationsPayload = {
  method: string;
  methodEn: string;
  combineTraining: boolean;
  combineCertification: boolean;
  isCombining: boolean;
  standardCountIndicatorId: number;
  educationRequirement: number;
  isEducationRequirementPercentage: boolean;
  certificationRequirement: number;
  isCertificationRequirementPercentage: boolean;
  positionIds: number[];
  laCourses: number[];
  isCategoryDealerException: boolean;
  categoryDealerExceptions: string[];
  requiredCoursesCount: number | null;
  requiredCoursesLevelId: number | null;
  ignoreTrainingStart: boolean;
};

export async function employeeExpectationsRequest(
  method: "POST" | "PUT" | "DELETE",
  data: object,
) {
  try {
    const response = await fetch(`/internal-api/employee/expectations`, {
      method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    try {
      return await response.json();
    } catch {
      return { success: true };
    }
  } catch (error) {
    console.error("Ошибка при обновлении ожиданий: ", error);
    throw error;
  }
}
